import React, { useState } from "react";
import { Card, Form, Input, Button, message, Typography, Checkbox } from "antd";
import { UserOutlined, LockOutlined, PhoneOutlined } from "@ant-design/icons";
import { useNavigate, Link } from "react-router-dom";
import { register } from "../services/api";
import SiteFooter from "../components/SiteFooter";
import PagePicture from "../components/PagePicture";

const { Title } = Typography;

const RegisterScreen = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onFinish = async (values) => {
        try {
            setLoading(true);
            const { agreement, ...account } = values;
            await register(account);
            message.success("注册成功，请登录");
            navigate("/login");
        } catch (error) {
            message.error(error?.error || "注册失败");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <PagePicture desktopSlot="auth_background_desktop" mobileSlot="auth_background_mobile" className="auth-page-background" alt="看屋子注册背景" />
            <Card style={{ width: 400, maxWidth: "100%" }}>
                <Title level={2} style={{ textAlign: "center", marginBottom: 4 }}>注册看屋子账号</Title>
                <div style={{ textAlign: "center", color: "#8c8c8c", marginBottom: 24 }}>用于找房、租住和房屋管理</div>
                <Form onFinish={onFinish} size="large">
                    <Form.Item name="username" rules={[{ required: true, message: "请输入用户名" }, { min: 2, max: 30, message: "用户名需为2至30个字符" }]}>
                        <Input prefix={<UserOutlined />} placeholder="用户名" />
                    </Form.Item>
                    <Form.Item name="password" rules={[
                        { required: true, message: "请输入密码" },
                        { min: 8, max: 64, message: "密码需为8至64位" },
                        { pattern: /^(?=.*[A-Za-z])(?=.*\d).+$/, message: "密码必须同时包含字母和数字" }
                    ]}>
                        <Input.Password prefix={<LockOutlined />} placeholder="至少8位，包含字母和数字" />
                    </Form.Item>
                    <Form.Item name="phone">
                        <Input prefix={<PhoneOutlined />} placeholder="手机号（选填）" />
                    </Form.Item>
                    <Form.Item name="wechat">
                        <Input placeholder="微信号（选填）" />
                    </Form.Item>
                    <Form.Item name="agreement" valuePropName="checked" rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error("请先阅读并同意服务协议和隐私政策")) }]}>
                        <Checkbox>我已阅读并同意 <Link to="/agreement">用户服务协议</Link> 和 <Link to="/privacy">隐私政策</Link></Checkbox>
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" loading={loading} block>注册</Button>
                    </Form.Item>
                    <div style={{ textAlign: "center" }}>
                        <Link to="/login">已有账号？去登录</Link>
                    </div>
                </Form>
            </Card>
            <SiteFooter compact />
        </div>
    );
};

export default RegisterScreen;
